export default __webpack_public_path__ + "static/media/Packers.99da64e0.png";